import { render, staticRenderFns } from "./Partner-cards.vue?vue&type=template&id=f274a724&"
import script from "./Partner-cards.vue?vue&type=script&lang=js&"
export * from "./Partner-cards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports